import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "../../context/axios";

import ShowRelated from "./Services/Booking";
import BookinRegion from "./Services/BookingRegion";
import ImageGalleryModal from "./Services/ImageGalleryModal";
import EnquiryModal from "./Services/EnquiryModal";

const TourDetails = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const { id } = useParams();
  const [tour, setTour] = useState(null);
  const providedServices = tour?.providedServices || [];
  const galleryImages = [tour?.img, ...(tour?.subCategoryImages || [])];
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTransport, setSelectedTransport] = useState("flight");
  const [transportType, setTransportType] = useState("flight");
  const [loading, setLoading] = useState(true); // <-- Add this at top with other states

  const parsedServices =
    providedServices && providedServices[0]
      ? JSON.parse(providedServices[0])
      : [];
  
  // useEffect(() => {
  //   const fetchTour = async () => {
  //     try {
  //       const res = await fetch(`h/tours/${id}`);
  //       const data = await res.json();
  //       console.log("Tour fetched:", data.data.oneTour);
  //       setTour(data.data.oneTour);
  //     } catch (err) {
  //       console.error("Failed to fetch tour:", err);
  //     }
  //   };
  //   window.scrollTo(0, 0);
  //   fetchTour();
  // }, [id]);

  // useEffect(() => {
  //   const fetchTour = async () => {
  //     try {
  //       const res = await axios.get(`/tours/${id}`); // Ensure your baseURL is set in axios
  //       console.log("Tour fetched:", res.data.data.oneTour);
  //       setTour(res.data.data.oneTour);
  //     } catch (err) {
  //       console.error("Failed to fetch tour:", err);
  //     }
  //   };
  
  //   window.scrollTo(0, 0);
  //   fetchTour();
  // }, [id]);
  

  useEffect(() => {
    const fetchTour = async () => {
      try {
        const res = await axios.get(`/tours/${id}`);
        console.log("Tour fetched:", res.data.data.oneTour);
        setTour(res.data.data.oneTour);
      } catch (err) {
        console.error("Failed to fetch tour:", err);
      } finally {
        setLoading(false); // <-- Important!
      }
    };
  
    window.scrollTo(0, 0);
    fetchTour();
  }, [id]);


  // if (!tour) {
  //   return (
  //     <div className="h-[90vh] flex flex-col items-center justify-center text-center px-4 bg-white rounded-xl">
  //       <img
  //         src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
  //         alt="No data"
  //         className="w-24 h-24 mb-4 opacity-70"
  //       />
  //       <h2 className="text-xl font-semibold text-gray-700 mb-2">
  //         Tour Not Found
  //       </h2>
  //       <p className="text-gray-500 mb-4 max-w-md">
  //         The tour you are looking for could not be found or is no longer
  //         available. Please explore our other exciting packages!
  //       </p>
  //       <a
  //         href="/tours"
  //         className="inline-block px-6 py-2.5 bg-blue-600 text-white font-semibold rounded shadow hover:bg-blue-700 transition"
  //       >
  //         Explore Tours
  //       </a>
  //     </div>
  //   );
  // }

  if (loading) {
    return (
      <div className="h-[90vh] flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-opacity-70"></div>
      </div>
    );
  }
  
  if (!tour) {
    return (
      <div className="h-[90vh] flex flex-col items-center justify-center text-center px-4 bg-white rounded-xl">
        <img
          src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
          alt="No data"
          className="w-24 h-24 mb-4 opacity-70"
        />
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          Tour Not Found
        </h2>
        <p className="text-gray-500 mb-4 max-w-md">
          The tour you are looking for could not be found or is no longer
          available. Please explore our other exciting packages!
        </p>
        <a
          href="/tours"
          className="inline-block px-6 py-2.5 bg-blue-600 text-white font-semibold rounded shadow hover:bg-blue-700 transition"
        >
          Explore Tours
        </a>
      </div>
    );
  }

  return (
    <div className="font-sans w-full px-4 py-6 md:px-10 md:py-10 max-w-7xl mx-auto">

      
      <ImageGalleryModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        images={galleryImages}
        currentIndex={selectedImageIndex}
      />
      {/* Header */}
      <div className="border-b pb-4">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
          {tour?.title}
        </h1>
     
        <div className="flex items-center gap-3 mt-2">
          <span className="text-xl">
            {[...Array(5)].map((_, i) => (
              <span
                key={i}
                className={
                  i < Math.round(tour?.averageRating || 0)
                    ? "text-yellow-400"
                    : "text-gray-300"
                }
              >
                ★
              </span>
            ))}
          </span>
          {/* <span className="bg-gray-200 text-xs px-2 py-1 rounded">
            Airport shuttle
          </span> */}
        </div>
      </div>

      {/* Grid Section */}
      <div className="mt-6 flex flex-col lg:flex-row gap-6">
        <div className="w-full lg:w-2/3 grid grid-cols-2 grid-rows-3 md:grid-cols-4 md:grid-rows-2 gap-2 h-auto md:h-[400px] lg:h-[500px]">
          {/* Main Image (First) */}
          <div className="row-span-2 col-span-2">
            <img
              src={tour?.img}
              alt="Main"
              className="w-full h-full object-cover rounded-xl"
              onClick={() => {
                setSelectedImageIndex(0);
                setIsModalOpen(true);
              }}
            />
          </div>

          {/* Sub Images (up to 4 from subCategoryImages) */}
          {tour?.subCategoryImages?.slice(0, 7).map((url, idx) => (
            <img
              key={idx}
              src={url}
              alt={`Sub ${idx + 1}`}
              className="w-full h-full object-cover rounded-xl"
              onClick={() => {
                setSelectedImageIndex(idx + 1); // +1 because main image is index 0
                setIsModalOpen(true);
              }}
            />
          ))}

         
          {tour?.subCategoryImages?.length > 9 && (
            <div
              className="relative cursor-pointer"
              onClick={() => {
                setSelectedImageIndex(9 + 1); // 9th sub-image (index 8) + 1 for main image
                setIsModalOpen(true);
              }}
            >
              <img
                src={tour.subCategoryImages[9]}
                alt="More Photos"
                className="w-full h-full object-cover rounded-xl"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center rounded-xl">
                <span className="text-white font-semibold text-sm md:text-lg">
                  +{tour.subCategoryImages.length - 9} photos
                </span>
              </div>
            </div>
          )}
        </div>

    
        <div className="w-full lg:w-1/3 space-y-6">
          {/* Price & EMI */}
          <div className="bg-blue-100 p-4 md:p-5 rounded-2xl shadow-md space-y-2">
            {/* Transportation Toggle - Only show if both options available */}
            {(tour?.originalPrice || tour?.trainOriginalPrice) && (
              <div className="flex border rounded-lg bg-white overflow-hidden mb-3">
                {/* Flight Option */}
                <button
                  className={`flex-1 py-2 text-sm font-medium flex items-center justify-center gap-1 transition-colors ${
                    transportType === "flight"
                      ? "bg-blue-600 text-white"
                      : tour?.originalPrice
                      ? "bg-white text-gray-700 hover:bg-gray-50"
                      : "bg-gray-100 text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() =>
                    tour?.originalPrice && setTransportType("flight")
                  }
                  disabled={!tour?.originalPrice}
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                    />
                  </svg>
                  Flight
                  {!tour?.originalPrice && (
                    <span className="text-xs ml-1">(N/A)</span>
                  )}
                </button>

                {/* Train Option */}
                <button
                  className={`flex-1 py-2 text-sm font-medium flex items-center justify-center gap-1 transition-colors ${
                    transportType === "train"
                      ? "bg-blue-600 text-white"
                      : tour?.trainOriginalPrice
                      ? "bg-white text-gray-700 hover:bg-gray-50"
                      : "bg-gray-100 text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() =>
                    tour?.trainOriginalPrice && setTransportType("train")
                  }
                  disabled={!tour?.trainOriginalPrice}
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                    />
                  </svg>
                  Train
                  {!tour?.trainOriginalPrice && (
                    <span className="text-xs ml-1">(N/A)</span>
                  )}
                </button>
              </div>
            )}

            {/* Price Display */}
            {transportType === "flight" ? (
              <>
                {tour?.originalPrice && (
                  <p className="text-gray-500 line-through text-xs md:text-sm">
                    € {tour?.originalPrice}
                  </p>
                )}
                <p className="text-2xl md:text-3xl font-bold text-gray-900">
                  {tour?.price ? `€ ${tour?.price}` : "Price not available"}{" "}
                  {tour?.price && (
                    <span className="text-sm md:text-base font-medium">
                      /person
                    </span>
                  )}
                </p>
              </>
            ) : (
              <>
                {tour?.trainOriginalPrice && (
                  <p className="text-gray-500 line-through text-xs md:text-sm">
                    € {tour?.trainOriginalPrice}
                  </p>
                )}
                <p className="text-2xl md:text-3xl font-bold text-gray-900">
                  {tour?.trainPrice
                    ? `€ ${tour?.trainPrice}`
                    : "Price not available"}{" "}
                  {tour?.trainPrice && (
                    <span className="text-sm md:text-base font-medium">
                      /person
                    </span>
                  )}
                </p>
              </>
            )}

            {/* EMI Calculation - Only show if price available */}
            {(transportType === "flight" ? tour?.price : tour?.trainPrice) && (
              <p className="text-xs md:text-sm text-gray-700">
                No Cost EMI from{" "}
                <span className="font-semibold text-blue-700">
                  € 
                  {Math.floor(
                    (transportType === "flight"
                      ? tour?.price
                      : tour?.trainPrice) / 4.8
                  )}
                </span>{" "}
                per month only
              </p>
            )}

            <button
              onClick={() => setModalOpen(true)}
              className="mt-3 w-full max-w-xs bg-blue-600 text-white rounded-full py-2 md:py-3 text-xs md:text-sm font-semibold hover:bg-blue-700 transition"
              disabled={
                !(transportType === "flight" ? tour?.price : tour?.trainPrice)
              }
            >
              {(transportType === "flight" ? tour?.price : tour?.trainPrice)
                ? "ENQUIRE NOW"
                : "PRICE NOT AVAILABLE"}
            </button>

            <EnquiryModal
              isOpen={modalOpen}
              onClose={() => setModalOpen(false)}
              tour={tour}
              transportType={transportType}
            />

            {/* <p className="text-xs text-gray-600 text-center mt-2">
              Hurry! Offer valid till{" "}
              <span className="font-semibold">June 5th</span>
            </p> */}
          </div>

          {/* Package Summary */}
          <div className="bg-white border rounded-2xl p-4 md:p-5 shadow-md space-y-4">
            <div className="space-y-1 text-sm md:text-base">
              <p>
                <span className="text-pink-600 font-semibold">Duration:</span>
                {/* 4
                Nights & 5 Days */}
                {tour?.duration?.night} Nights {tour?.duration?.day} Days
              </p>
              <p>
                <span className="text-red-600 font-semibold">
                  Places to Visit:
                </span>{" "}
                {/* 02N Port Blair | 02N Havelock */}
                {tour?.cities}
              </p>
            </div>

            <div className="flex flex-wrap gap-2">
              {parsedServices.map((service) => (
                <div
                  key={service}
                  className="flex items-center gap-1 px-3 py-1 bg-gray-100 rounded-md text-sm font-medium text-gray-700"
                >
                  <svg
                    className="w-4 h-4 text-green-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span>{service}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Help Section */}
          <div className="bg-white border rounded-2xl p-4 md:p-5 shadow-md flex gap-3 md:gap-4 items-start">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6 md:w-8 md:h-8 mt-1 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={1.5}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M18.364 5.636a9 9 0 1 0-12.728 12.728A9 9 0 1 0 18.364 5.636z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 8v4l2.5 1.5"
                />
              </svg>
            </div>
            <div className="space-y-1 text-xs md:text-sm">
              <p className="font-semibold text-sm md:text-base">Need Help?</p>
              <p>
                📞 <span className="font-medium">+49 1512 3456789</span>
              </p>
              <p>
                ✉️ <span className="font-medium">holidays.tripnest@gmail.com</span>
              </p>
              <p className="text-gray-500 text-xs">
                Customer support 9AM–9PM, 7 days a week
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Facilities Section */}
      {/* <div className="bg-white border rounded-2xl p-4 md:p-6 shadow-md mt-8 md:mt-10 w-full">
        <h3 className="text-lg font-semibold mb-4 md:mb-5 text-gray-800">
          Top Facilities
        </h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-6 text-sm text-gray-700">
          {[
            { icon: <WifiIcon className="w-6 h-6" />, label: "Free Wi-Fi" },
            { icon: <FireIcon className="w-6 h-6" />, label: "Heated Pool" },
            { icon: <TruckIcon className="w-6 h-6" />, label: "Free Parking" },
            {
              icon: <AcademicCapIcon className="w-6 h-6" />,
              label: "Fitness Center",
            },
            {
              icon: <SparklesIcon className="w-6 h-6" />,
              label: "Spa Services",
            },
            {
              icon: <DevicePhoneMobileIcon className="w-6 h-6" />,
              label: "Smart AC Rooms",
            },
          ].map((item, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center text-center transition hover:scale-105"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-blue-50 rounded-full shadow text-blue-600">
                {item.icon}
              </div>
              <span className="mt-2 text-xs md:text-sm">{item.label}</span>
            </div>
          ))}
        </div>
      </div> */}

      {/* <div className="mt-8 md:mt-12 w-full">
        <div className="flex flex-col md:flex-row gap-4 md:gap-6">
          <div className="w-full md:w-1/2 bg-green-50 border border-green-200 rounded-2xl p-4 md:p-6 shadow">
            <h3 className="text-lg font-semibold text-green-800 mb-3 md:mb-4">
               Inclusions
            </h3>
            <ul className="list-disc list-inside text-xs md:text-sm text-gray-700 space-y-2">
              <li>Link/Bhagya Express/Green Ocean I/ITT Majestic.</li>
              <li>
                Snorkelling complimentary trip to Elephant Beach at Havelock
                Island by High Speed Fibre Boats.
                <br />
                <span className="text-xs italic">
                  (On Sharing Basis one Snorkeling Session is a part of the
                  Ticket price for Elephant Beach)
                </span>
              </li>
              <li>Jet Ski at Havelock/Port Blair</li>
              <li>
                Return Trip to Havelock & Neil Island from Port Blair by Green
                Ocean/Nautika/ITT Majestic/Sea Link
              </li>
            </ul>
          </div>

          <div className="w-full md:w-1/2 bg-red-50 border border-red-200 rounded-2xl p-4 md:p-6 shadow">
            <h3 className="text-lg font-semibold text-red-800 mb-3 md:mb-4">
              ❌ Exclusions
            </h3>
            <ul className="list-disc list-inside text-xs md:text-sm text-gray-700 space-y-2">
              <li>Airfares/Ship Fare to Mainland.</li>
              <li>Personal Expenses and Additional Tour Or Vehicle Usage.</li>
              <li>Room Service, Laundry, Telephone Charges.</li>
              <li>Activity Charges, Scuba, Jet Ski, Snorkeling Etc.</li>
              <li>Expenses Due to Bad Weather or Flight Cancellation.</li>
            </ul>
          </div>
        </div>
      </div> */}

      <div className="mt-8 md:mt-12 w-full">
        <div className="flex flex-col md:flex-row gap-4 md:gap-6">
          {/* Inclusions - Left Side */}
          <div className="w-full md:w-1/2 bg-green-50 border border-green-200 rounded-2xl p-4 md:p-6 shadow">
            <h3 className="text-lg font-semibold text-green-800 mb-3 md:mb-4">
               Inclusions
            </h3>
            <ul className="list-disc list-inside text-xs md:text-sm text-gray-700 space-y-2">
              {/* {tour?.Inclusions &&
                Object.values(tour.Inclusions).map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))} */}
              {tour?.Inclusions &&
                Object.entries(tour.Inclusions).map(([key, value], idx) => (
                  <li key={idx}>
                    <strong className="text-green-700 capitalize mr-1"></strong>
                    {value}
                  </li>
                ))}
            </ul>
          </div>

          {/* Exclusions - Right Side */}
          <div className="w-full md:w-1/2 bg-red-50 border border-red-200 rounded-2xl p-4 md:p-6 shadow">
            <h3 className="text-lg font-semibold text-red-800 mb-3 md:mb-4">
              ❌ Exclusions
            </h3>
            <ul className="list-disc list-inside text-xs md:text-sm text-gray-700 space-y-2">
              {/* {tour?.Exclusions &&
                Object.values(tour.Exclusions).map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))} */}
              {tour?.Exclusions &&
                Object.entries(tour.Exclusions).map(([key, value], idx) => (
                  <li key={idx}>
                    <strong className="text-red-700 capitalize mr-1"></strong>
                    {value}
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="bg-white border rounded-2xl p-4 md:p-6 shadow-md mt-8 md:mt-10 w-full">
        <div className="max-w-7xl mx-auto">
          <h3 className="text-2xl md:text-4xl font-bold text-gray-800 mb-8 md:mb-16">
            Tour Itinerary
          </h3>

          <div className="relative border-l-4 border-blue-200 pl-4 md:pl-6">
            {tour?.dayDescriptions &&
              Object.entries(tour.dayDescriptions).map(([key, item], index) => (
                <div key={index} className="mb-12 md:mb-16 relative">
                  {/* Day Badge */}
                  <div className="absolute -left-[2.8rem] md:-left-[3.2rem] top-0">
                    <div className="flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 text-white font-bold shadow-lg text-xs md:text-sm">
                      {key.replace("day", "Day ")}
                    </div>
                  </div>

                  {/* Timeline Card */}
                  <div className="ml-6 md:ml-8">
                    <div className="rounded-xl overflow-hidden border border-blue-200 shadow hover:shadow-lg transition">
                      {/* Header */}
                      <div className="bg-gradient-to-r from-blue-100 to-blue-200 px-4 py-2 md:px-5 md:py-3">
                        <h3 className="text-xs md:text-sm font-semibold text-blue-900 uppercase tracking-wide">
                          {item.title}
                        </h3>
                      </div>

                      {/* Body */}
                      <div className="bg-white p-4 md:p-5 text-xs md:text-sm lg:text-base text-gray-700 leading-relaxed">
                        {item.description}
                        <div className="mt-4 flex flex-wrap gap-3">
                          {item.images?.map((img, idx) => (
                            <img
                              key={idx}
                              src={img}
                              alt={`Day ${index + 1} - ${idx}`}
                              className="w-28 h-20 object-cover rounded-lg shadow"
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* Terms & Conditions */}
      <div className="bg-white border rounded-2xl p-4 md:p-6 shadow-md mt-8 md:mt-12 w-full">
        <h2 className="text-2xl font-semibold border-l-4 border-blue-500 pl-4 mb-8 text-gray-900">
          Terms & Conditions
        </h2>

        {/* Cards Container */}
        <div className="space-y-6">
          {/* Each Card */}
          {[
            // {
            //   title: "Travel Validity",
            //   content: ["The deal is valid for travel till 31 Dec 2025."],
            // },
            {
              title: "Guaranteed Dates",
              content: [
                "Your selected travel dates are guaranteed. In the unlikely event of seats sold out, we guarantee +/- 1/2 days from your preferred dates.",
              ],
            },
            {
              title: "Easy Cancellation",
              content: [
                "30 days or more prior to departure date, Initial Booking Amount amount will be forfeited.",
                "Between 30–15 days: 50% of total tour cost will be charged as penalty.",
                "Less than 15 days: 100% of total tour cost will be charged as penalty.",
              ],
            },
          ].map((section, idx) => (
            <div
              key={idx}
              className="bg-blue-50 border border-blue-200 rounded-xl shadow-sm overflow-hidden"
            >
              <div className="bg-blue-100 px-5 py-3 text-blue-900 font-semibold text-base md:text-sm border-b border-blue-200">
                {section.title}
              </div>
              <div className="px-6 py-4 text-gray-800 text-sm leading-relaxed">
                <ul className="list-disc list-inside space-y-2">
                  {section.content.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 px-4">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Similar {tour?.category?.name} Holiday Packages You Might Like
        </h2>
        {tour?.category && <ShowRelated categoryId={tour.category._id} />}
      </div>

      <div className="max-w-7xl mx-auto mt-16 px-4">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Explore Packages in {tour?.region?.name}{" "}
        </h2>

        {tour?.region && <BookinRegion region={tour.region} />}
      </div>
    </div>
  );
};

export default TourDetails;
